import React from 'react';

import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import { downloadFile } from '../AttachChildDucks';

export default function UploadFiles({ files }) {
  const { t } = useTranslation();

  const handleDownload = file => {
    if (!file?.documentLink || !file.documentName) return;
    downloadFile(file);
  };

  return (
    <Grid item xs={12} md={12}>
      <Typography variant="body1">{t('attachChild_attachFile')}</Typography>
      <ol
        style={{ paddingLeft: '20px', margin: '0', fontSize: '16px', fontWeight: '400' }}
      >
        {files?.map(file => {
          console.log('file', file);
          return (
            <li
              key={file.documentName}
              style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}
            >
              <div style={{ marginRight: '8px' }}>
                <Typography variant="body1">{file.documentName}</Typography>
              </div>

              <IconButton
                color="primary"
                aria-label="upload file"
                component="span"
                onClick={() => {
                  handleDownload(file);
                }}
              >
                <FileDownloadIcon />
              </IconButton>
            </li>
          );
        })}
      </ol>
    </Grid>
  );
}
